import React from 'react';
import { TranslationKeys } from '../../../../enums/translationKeys';

const InfoTextBlock = ({ t }) => {
  return (
    <div className='fs-help-popup-text'>
      <p>{t(TranslationKeys.GAME_RULES_P1)}</p>
      <p className='text-b'>{t(TranslationKeys.GAME_RULES_P2)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P31)}</p>
      <p className='text-b'>{t(TranslationKeys.GAME_RULES_P4)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P5)}</p>
      <p className='text-b'>{t(TranslationKeys.GAME_RULES_P6)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P7)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P41)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P8)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P21)}</p>
      <p className='text-b'>{t(TranslationKeys.GAME_RULES_P9)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P10)}</p>
      <p>
        {t(TranslationKeys.CancelationMessage_1)} <br /> {t(TranslationKeys.MalfunctionMessage_2)}
      </p>
      <p>{t(TranslationKeys.RTP)}</p>
    </div>
  );
};

export default InfoTextBlock;
